import React from 'react';

const Footer = () => {
  return (
    <div className="footer-container">
      <p>@ 2024 Sarthak Institute Kotdwara</p>
    </div>
  );
};

export default Footer;
